export const JWT_KEY = 'jwt:admin';
